import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import lazyWithReload from '../../utils/lazyWithReload';
import ProjectDetail from '../../components/ProjectDetail';
import { useEntitlements } from '../entitlements';
import { asksForDesignPage } from '../jobPageModel';

// the books job page, loaded for contractors only
const ContractorProjectPage = lazyWithReload(
  () => import('./ContractorProjectPage')
);

/**
 * `/project/:id` (phase 3 spec 2026-09-26 §4, "Routes"): a marked
 * contractor's own or organization's project opens as a job — the design and
 * the books on one page. Everyone else keeps today's ProjectDetail, and never
 * reads the project twice or downloads the books.
 *
 * In an admin's read-only view of another organization (phase 3d §7) the
 * desk is that organization's books; a design project is the design app's,
 * outside the view, so it opens as today's page there too.
 *
 * `?view=design` (`designPagePath`, the classic `/projects` list's link)
 * asks for today's page whoever is asking.
 */
export default function ProjectJobRoute() {
  const { contractor, adminView } = useEntitlements();
  const { search } = useLocation();
  return contractor && !adminView && !asksForDesignPage(search) ? (
    <Suspense fallback={null}>
      <ContractorProjectPage />
    </Suspense>
  ) : (
    <ProjectDetail />
  );
}
